import React, { createContext, useContext, useReducer } from "react";
import axios from "axios";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { loanApplicationStatus } from "assets/properties/properties";
// import * as XLSX from "xlsx";
// import * as XLSX from 'xlsx/xlsx.mjs';
export const StateContext = createContext();
export const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);
export const useStateValue = () => useContext(StateContext);
// const Context = React.createContext({ authenticated: false });

export const registerToken = () => {
  const code = {
    grant_type: "refresh_token",
    refresh_token: localStorage.getItem("refresh_token"),
  };
  axios({
    method: "post",
    url: "fx-auth-server/oauth/token",
    data: code,
  }).then((response) => {
    if (response.data.access_token) {
      localStorage.setItem("token", response.data.access_token);
      localStorage.setItem("role", response.data.role);
      localStorage.setItem(
        "customerId",
        response.data.customerId ? response.data.customerId : -1
      );
      localStorage.setItem("tokenTime", Date.now());
      localStorage.setItem("view_as_client", response.data.view_as_client);
      localStorage.setItem(
        "readonly_customer",
        response.data.readonly_customer
      );
      localStorage.setItem("refresh_token", response.data.refresh_token);
      let status = "prospect";
      if (response.data.view_as_client) status = "view_as_client";
      else {
        if (response.data.is_user_admin) {
          status = "admin";
        } else if (response.data.prospectUser) {
          if (response.data.customerId) status = "registered";
          else status = "prospect";
        } else status = "approved";
      }
      localStorage.setItem("status", status);
    }
  });
};

export const refreshToken = () => {
  //clearInterval(tokenCheck);
  if (!window.tokenCheck) {
    let requestPending = false;
    window.tokenCheck = setInterval(() => {
      if (localStorage.getItem("refresh_token")) {
        const time =
          (Date.now() - localStorage.getItem("tokenTime")) / (1000 * 60);
        if (time > 4 && !requestPending) {
          requestPending = true;
          const code = {
            grant_type: "refresh_token",
            refresh_token: localStorage.getItem("refresh_token"),
          };
          axios({
            method: "post",
            url: "fx-auth-server/oauth/token",
            data: code,
          }).then((response) => {
            if (response.data.access_token) {
              localStorage.setItem("token", response.data.access_token);
              localStorage.setItem(
                "customerId",
                response.data.customerId ? response.data.customerId : -1
              );
              localStorage.setItem("role", response.data.role);
              localStorage.setItem("tokenTime", Date.now());
              localStorage.setItem(
                "view_as_client",
                response.data.view_as_client
              );
              localStorage.setItem(
                "readonly_customer",
                response.data.readonly_customer
              );
              localStorage.setItem(
                "refresh_token",
                response.data.refresh_token
              );
              let status = "prospect";
              if (response.data.view_as_client) status = "view_as_client";
              else {
                if (response.data.is_user_admin) {
                  status = "admin";
                } else if (response.data.prospectUser) {
                  if (response.data.customerId) status = "registered";
                  else status = "prospect";
                } else status = "approved";
              }
              localStorage.setItem("status", status);
              requestPending = false;
            }
          });
        }
      }
    }, 5000);
  }
};

export const parseCurrency = (amount) => {
  if (amount && isNaN(amount) && amount.indexOf(",") !== -1) {
    let newAmount = "";
    let amountArr = amount.split(",");
    for (var k = 0; k < amountArr.length; k++) {
      // Trim the excess whitespace.
      amountArr[k] = amountArr[k].replace(/^\s*/, "").replace(/\s*$/, "");
      // Add additional code here, such as:
      newAmount = newAmount.concat(amountArr[k]);
    }
    amount = newAmount;
  }
  return amount;
};
// export const workbook2blob = (workbook) => {
//   const wopts = {
//     bookType: "xlsx",
//     bookSST: false,
//     type: "binary",
//   };
//   const wbout = XLSX.write(workbook, wopts);
//   // Convert string to ArrayBuffer
//   function s2ab(s) {
//     const buf = new ArrayBuffer(s.length);
//     const view = new Uint8Array(buf);
//     for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
//     return buf;
//   }
//   const blob = new Blob([s2ab(wbout)], {
//     type: "application/octet-stream",
//   });
//   return blob;
// };
export const formatMoney = (
  amount,
  decimalCount = 2,
  decimal = ".",
  thousands = ","
) => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    // console.log(e);
  }
};

export const formatDate = (dateObj) => {
  if (dateObj === null || dateObj === "") return null;

  var monthNames = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  var date = new Date(dateObj);
  date =
    date.getDate() +
    " " +
    monthNames[date.getMonth()] +
    " " +
    date.getFullYear();
  return date;
};
export const formateReportDate = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return date + "-" + month + "-" + dateObj.getFullYear();
};

export const parseDate = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return dateObj.getFullYear() + "-" + month + "-" + date;
};
export const parseDateTime = (weekDate) => {
  if (weekDate === null || weekDate === "") return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  var today = new Date();
  var min = today.getMinutes();
  if (min < 10) {
    min = "0" + min;
  }
  var time = today.getHours() + ":" + min;

  return dateObj.getFullYear() + "-" + month + "-" + date + " " + time;
};

export const shortenDealId = (dealId) => {
  let newDealId = dealId;
  let index = dealId.lastIndexOf("-");
  if (index !== -1) {
    newDealId = dealId.substring(index + 1, dealId.length);
  }
  return newDealId;
};
export const sortArray = (arr, key, sortByAscending, dataType) => {
  let data =
    dataType === "string"
      ? sortByString(arr, key, sortByAscending)
      : dataType === "date"
      ? sortByDate(arr, key, sortByAscending)
      : dataType === "number"
      ? sortByNumber(arr, key, sortByAscending)
      : arr;
  return data;
};
export const sortByNumber = (arr, key, ascending) => {
  arr.sort((a, b) => {
    if (parseFloat(a[key]) < parseFloat(b[key])) {
      return ascending ? -1 : 1;
    } else {
      return ascending ? 1 : -1;
    }
  });
  return arr;
};
export const sortByString = (arr, key, ascending) => {
  arr?.sort((a, b) => {
    if (a[key] < b[key]) {
      return ascending ? -1 : 1;
    } else {
      return ascending ? 1 : -1;
    }
  });
  return arr;
};
export const sortByDate = (arr, key, ascending) => {
  arr.sort((a, b) => {
    if (ascending) {
      return new Date(a[key]).getTime() - new Date(b[key]).getTime();
    } else {
      return new Date(b[key]).getTime() - new Date(a[key]).getTime();
    }
  });
  return arr;
};
export const formatErrString = (myJSON) => {
  var myJSONString = JSON.stringify(myJSON);
  var myEscapedJSONString = myJSONString
    .replace(/\\n/g, "\\n")
    .replace(/\\'/g, "\\'")
    .replace(/\\"/g, '\\"')
    .replace(/\\&/g, "\\&")
    .replace(/\\r/g, "\\r")
    .replace(/\\t/g, "\\t")
    .replace(/\\b/g, "\\b")
    .replace(/\\f/g, "\\f");
  return JSON.parse(myEscapedJSONString);
};

export const SearchTable = (tableData, keys, searchParam) => {
  let filteredData = [];
  if (tableData && tableData.length > 0) {
    filteredData = tableData.filter((row) => {
      let isExists = false;
      keys &&
        keys.forEach((key) => {
          if (typeof row[key] === "string") {
            isExists =
              isExists ||
              row[key].toLowerCase().includes(searchParam.toLowerCase());
          }
        });
      return isExists;
    });
  }
  return filteredData;
};
export const formatReportDate = (item) => {
  let dd = new Date();
  if (item) {
    // if (typeof item === "object") {
    //   return formatDate(item);
    // } else {
    return new Date(item);

    // const [year, month, day] = item.split("-");
    // const date = day + "-" + month + "-" + year;
    // return date;
    // }
  } else return "";
};
export const formatReportMoney = (item) => {
  let value = Number(item);
  // if (Number(value) < 0) {
  //   value = "-" + Math.abs(Number(value));
  // }
  return value ? value : "0.00";
};

export const textFormat = (text) => {
 const abc =  text?.toLowerCase()
  .split(' ')
  .map((s) => s?.charAt(0).toUpperCase() + s.substring(1))
  .join(' ');
  return abc;
}

export const removeUnderscoresAndCapitalize = (str) => {
  const words = str?.split('_');
  const capitalizedWords = words?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1));
  const result = capitalizedWords?.join(' ');
  return result;
};
// export { Context };

export const parseAndSetFlag = (flag) => {
  const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
 return parsedFlag;
};

export const adjustDate = (days) => {
  const date = new Date();
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

export const parseDateString = (dateString) => {
  const [day, month, year] = dateString.split('-');
  return new Date(year, month - 1, day); // month is zero-indexed
};

export const restructureArrayFunc = (arr) => {
  const nullChargeType = arr?.filter(item => item?.adjustment === null);
    const nonNullChargeType = arr?.filter(item => item?.adjustment !== null);

  return [...nullChargeType, ...nonNullChargeType];
};

export const calculateAge=(dob)=> {
  const birthDate = new Date(dob);
  const currentDate = new Date();

  let age = currentDate.getFullYear() - birthDate.getFullYear();
  const monthDifference = currentDate.getMonth() - birthDate.getMonth();

  // If the current month is before the birth month or it's the same month but the current day is before the birth day, subtract one from the age
  if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
}

export const validateDisbursalAmount = (data, premiumAmount) => {
  // Helper function to handle floating-point precision
  const toFixedPrecision = (num, precision = 2) =>
    parseFloat(num.toFixed(precision));

  // Calculate the total netPayable + adjustmentSum
  const netPayable = data.reduce((sum, item) => sum + (parseFloat(item.netPayable) || 0), 0);

  const adjustmentSum = data
    .filter((item) => item.adjustedAmount !== undefined)
    .reduce((sum, item) => sum + (parseFloat(item.adjustedAmount) || 0), 0); // Handle "" or null as 0

  const total = toFixedPrecision(netPayable + adjustmentSum + premiumAmount);

  // Check if any disbursalAmount matches the total
  const isValid = data.some(
    (item) => toFixedPrecision(parseFloat(item.disbursalAmount)) === total
  );

  return isValid;
};

export const formatAmount = (amount, showSymbol = true) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "";

  const formatter = new Intl.NumberFormat("en-IN", {
    style: showSymbol ? "currency" : "decimal",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount);
};

export const parseDateMDY = (weekDate) => {
  if (weekDate === null || weekDate === "" || !weekDate) return null;

  let dateObj = new Date(weekDate);

  var month =
    (dateObj.getMonth() + 1 < 10 ? "0" : "") + (dateObj.getMonth() + 1);
  var date = (dateObj.getDate() < 10 ? "0" : "") + dateObj.getDate();
  return  date + "-" + month + "-" + dateObj.getFullYear() ;
};

export const toCamelCase = (str) => {
  return str
      ?.replace(/[_-]/g, ' ')
      ?.split(' ')
      ?.map((word) => 
        word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
      )
      ?.join(' ');
};

export const getDateOnly = (date) =>  {
  return new Date(date).toISOString().split("T")[0];
}

export const parseDob = (dobString) => {
  if (!dobString) return null;

  let year, month, day;

  if (dobString.includes("-")) {
    // Format: YYYY-MM-DD
    [year, month, day] = dobString.split("-").map(Number);
  } else if (dobString.includes("/")) {
    // Format: DD/MM/YYYY
    [day, month, year] = dobString.split("/").map(Number);
  } else {
    return null;
  }

  const parsedDate = new Date(year, month - 1, day);
  return isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const removeSpecialCharFileName = (fileName) => {
  return fileName.replace(/[^a-zA-Z0-9.\-_]/g, "");
};

export const resizeImageByPercentage = (dataUri, percentage, callback, imageDimensions) => {
  const img = new Image();
  img.onload = function () {
    const canvas = document.createElement("canvas");

    let targetWidth;
    let targetHeight;

    if (Array.isArray(imageDimensions) && imageDimensions.length > 0) {
      // Extract first dimensions object
      const dims = imageDimensions[0];
      targetWidth = parseInt(dims.width, 10); // remove "px" if present
      targetHeight = parseInt(dims.height, 10);
      console.log(targetHeight,targetWidth,"fsdjgkjsgbkj")
    } else {
      // Fallback to percentage scaling
      targetWidth = img.width * (percentage / 100);
      targetHeight = img.height * (percentage / 100);
    }

    canvas.width = targetWidth;
    canvas.height = targetHeight;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

    const resizedDataUri = canvas.toDataURL("image/jpeg", 0.85); // Adjust quality as needed
    callback(resizedDataUri);
  };
  img.src = dataUri;
};

export const getPreviousDateAccToDays = (days) => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
};

export const removeUnderscores = (str) => {
  if (typeof str !== "string") return "";
  return str.replace(/_/g, " ");
}

export const getPreviousDateFromTheMaturityAccToDays = (date, days) => {
  if (!date) return null;
  const inputDate = new Date(date);
  const offset = isNaN(days) ? 0 : Number(days);
  inputDate.setDate(inputDate.getDate() - offset);
  return inputDate;
};

export const checkForRepledgeAccount = async (authToken,loanAccountNumber) => {
  try {
    const outstandingResult = await apiHandler({
      url:
        endpoint.CHECK_FOR_REPLEDGE_ACCOUNT_NUMEBR +
        "prePledgeloanAccountNumber=" +
        loanAccountNumber?.toUpperCase(),
      method: "GET",
      authToken: authToken,
    });

    console.log("API Response:", outstandingResult);
    return outstandingResult;
  } catch (error) {
    console.error("Error checking repledge account:", error);
  }
};


export const sortTabsByEnvOrder = (tabs, status, featureFlags) => {
  if (!featureFlags?.tabOrderByStatus) return tabs;
  let orderConfig = featureFlags.tabOrderByStatus;
  if (typeof orderConfig === "string") {
    try {
      orderConfig = JSON.parse(orderConfig);
    } catch {
      return tabs;
    }
  }
  const order = orderConfig;
  console.log(order, tabs, status,orderConfig,'sunglakskh');
  if (!Array.isArray(order)) return tabs;

  const orderIndex = {};
  order.forEach((id, index) => {
    orderIndex[id] = index;
  });
  return [...tabs].sort(
    (a, b) =>
      (orderIndex[a.id] ?? 999) - (orderIndex[b.id] ?? 999)
  );
};

  export const panAmountValidate = (checkActualLoanAmountPerYear, actualLoanAmount,  PANCRITERIA, iflActualLoanAmount, YEARLYPANCRITERIA ) => {
    if (checkActualLoanAmountPerYear) {
      if (Number(actualLoanAmount) > PANCRITERIA) {
        return true;
      } else if (iflActualLoanAmount > YEARLYPANCRITERIA) {
        return true;
      } else {
        return false;
      }
    } else {
      if (Number(actualLoanAmount) > PANCRITERIA) {
        return true;
      } else {
        return false;
      }
    }
  };

  export const normalizeTabOrderFlag = (value) => {
  // already an array (from default JSON)
  if (Array.isArray(value)) return value;

  // string (from .env)
  if (typeof value === "string") {
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error("Invalid TAB_ORDER_BY_STATUS:", value);
      return [];
    }
  }

  return [];
};

export const parseResponseData = (input) => {
  if (!input) return [];
  if (Array.isArray(input)) {
    return input;
  }
  if (typeof input === "object") {
    if (typeof input.data === "string") {
      return parseResponseData(input.data);
    }
    return [input];
  }

  if (typeof input === "string") {
    return input
      .split("\n")
      .filter(Boolean)
      .map((line) => {
        try {
          return JSON.parse(line);
        } catch (e) {
          console.error("Invalid JSON line:", line);
          return null;
        }
      })
      .filter(Boolean);
  }

  return [];
};

export const parseDateTimeMDY = (weekDate) => {
  if (!weekDate) return null;
  let dateObj = new Date(weekDate);
  let month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  let date = dateObj.getDate().toString().padStart(2, "0");
  let year = dateObj.getFullYear();
  let hours = dateObj.getHours().toString().padStart(2, "0");
  let minutes = dateObj.getMinutes().toString().padStart(2, "0");
  let seconds = dateObj.getSeconds().toString().padStart(2, "0");

  return `${date}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

export const getDeviationCodes = (deviationJson) => {
  try {
    if (!deviationJson) return "N/A";

    const parsed = JSON.parse(deviationJson);

    if (!parsed?.deviations?.length) return "N/A";

    // Extract all codes
    return parsed.deviations.map(d => d.code).join(", ");

  } catch (error) {
    console.error("Deviation JSON parse error:", error);
    return "N/A";
  }
};

export const sanitizeLoanAccountNumber = (loanAccountNumber, flag) => {
  if (typeof loanAccountNumber !== "string") return loanAccountNumber;
  return parseAndSetFlag(flag) && loanAccountNumber.includes("/")
    ? loanAccountNumber.replace(/\//g, "_")
    : loanAccountNumber;
};

export const twoDecimalRegex = (val) => /^\d*\.?\d{0,2}$/.test(val);
export const numericValueRegex = (val) => /^\d*$/.test(val);
export const isValidValue = (value) => {
  return value !== undefined &&
       value !== null &&
      String(value)?.trim() !== "" &&
      String(value)?.toUpperCase() !== "NAN";
};

export const getEndpoint = (path, params = {}) => {
  const isEmpty = (value) => {
    if (value == null || value === "") return true;
    if (typeof value === "object" && Object.keys(value).length === 0) return true;
    return false;
  };
  let url = path.replace(/\{(\w+)\}/g, (_, key) =>
    isEmpty(params[key]) ? "" : params[key]
  );
  url = url
    .replace(/([?&][^=]+=)(?=&|$)/g, "")
    .replace(/\?&/, "?")
    .replace(/[?&]$/, "");

  return url;
};

export const maskMobileNumber = (mobileNumber) => {
  return String(mobileNumber || "").replace(/\d(?=\d{2})/g, "*");
};

export const isValidateOnlyAlphabets = (value, shouldValidate = false) => {
  if (!shouldValidate) {
    return true;
  }

  if (typeof value !== "string" || !value.trim()) {
    return false;
  }

  return /^[A-Za-z\s]+$/.test(value.trim());
};

export const capitalizeFirstLetter = (value) =>
  value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : "";